import React from "react";
import { Button } from "@mui/material";

const StripePaymentSuccess = () => {
  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div
        className="text-center shadow-lg p-5 rounded"
        style={{
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            fill="green"
            className="bi bi-check-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.97 10.03a.75.75 0 0 0 1.08 0l3.992-3.993a.75.75 0 1 0-1.06-1.06L7.5 8.44 6.062 7.002a.75.75 0 1 0-1.06 1.06l1.97 1.968z" />
          </svg>
        </div>
        <h1 className="mb-3 text-success">Payment Successful!</h1>
        <p className="text-muted mb-4">
          Thank you for your payment. Your transaction has been completed.
        </p>    
      </div>
    </div>
  );
};

export default StripePaymentSuccess;
